import { render, staticRenderFns } from "./SecondProduct.vue?vue&type=template&id=b7fdf11c&"
import script from "./SecondProduct.vue?vue&type=script&lang=js&"
export * from "./SecondProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports